import { Children, isValidElement } from 'react';
var Panels = function (_a) {
    var isPanelOpen = _a.isPanelOpen, children = _a.children;
    return Children.toArray(children).map(function (panel, panelIndex) {
        var id;
        if (isValidElement(panel)) {
            var panelId = panel.props.id;
            id = panelId;
        }
        return isPanelOpen(id, panelIndex) && panel;
    });
};
export default Panels;
